import axios from 'axios';

export const fetchCourses = async () => {
  const response = await axios.get(`/api/v1/courses`);
  return Object.values(response.data).map(course => ({
    value: course.id,
    label: course.courseName,
    ...course
  }));
};

export const fetchConfigData = async () => {
  const response = await axios.get('/api/v1/fee-calc-config');
  return response.data.data;
};

export const fetchCourseDetails = async (courseId) => {
  const response = await axios.get(`/api/v1/course/${courseId}`);
  return response.data.data;
};